import React from "react";
import "./css/ReplyCard.css";
import { Avatar } from "@mui/material";

const CommentCard = ({ content, replyUsername, time }) => {
  const [avatarSrc, setAvatarSrc] = React.useState(
    `${process.env.PUBLIC_URL}/images/defaultAvatar.jpg`
  );

  const handleAvatarError = () => {
    setAvatarSrc(`${process.env.PUBLIC_URL}/images/defaultAvatar.jpg`);
  };
  return (
    <div className="replyCard">
      <div className="userDetail">
        <div className="logoUsernameContainer">
          <Avatar
            src={avatarSrc}
            onError={handleAvatarError}
            alt="Avatar"
            sx={{ width: 29, height: 29, boxShadow: " 0px 0px 2px 0px grey" }}
          />
          <div className="username">{replyUsername}</div>
        </div>
        <div className="time">{new Date(time).toLocaleDateString()}</div>
        {/* <div className="likeCard">
          <div className="like">
            <FavoriteBorderIcon />
          </div>
          <p className="likeCount">400</p>
        </div> */}
      </div>
      <div className="textArea">{content}</div>
      {/* <div className="buttonArea">
        <div className="replyBtnContainer">
          <div className="reply">
            <div className="icon">
              <ChatRoundedIcon />
            </div>
            <div className="replyCount">View replies</div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default CommentCard;
